<div class="table-toggler" (click)="toggle()" [attr.data-test]="'toggle-button-' + (currentValue ? 'runs' : 'todos')">
	<span data-test="events-toggler-button" class="text left" [ngClass]="{ selected: !currentValue }">{{
		leftText
	}}</span>
	<div class="slider" [ngStyle]="{ 'margin-left': !currentValue ? '0px' : '115px' }"></div>
	<span class="text right" [ngClass]="{ selected: currentValue }" data-test="customers-toggler-button">{{
		rightText
	}}</span>
</div>
